export default __webpack_public_path__ + "static/media/dms.ba209ded.jpg";